/**
 * ProviderType — Enum loại provider đăng nhập + auth provider type
 * CreatedBy: dbhuan (14/06/2026)
 * UpdatedBy: dbhuan (16/06/2026) — them AUTH_MISA_ID, AUTH_JETPAY_ID
 */
export const ProviderType = {
  /** MISA ID */
  MISA_ID: "MISA_ID",
};

/** @typedef {"MC_AMIS"|"MISA_ID"} ProviderTypeValue */
